import React, { useState, FormEvent } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { BRIGHTSTONE_STORAGE_KEY } from "../contexts/AuthContext";

const PASSWORD = "brightstone123";

export default function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError("");
    if (!password.trim()) return;
    setIsLoading(true);
    if (password.trim() === PASSWORD) {
      sessionStorage.setItem(BRIGHTSTONE_STORAGE_KEY, "1");
      // Full page navigation so AuthContext re-reads sessionStorage and dashboard renders
      window.location.href = "/";
    } else {
      setError("Wrong password");
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-bold text-foreground">Brightstone</h1>
          <p className="text-sm text-muted-foreground">Enter password to continue</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              className="w-full"
              disabled={isLoading}
            />
            {error && (
              <p className="text-sm text-destructive">{error}</p>
            )}
          </div>
          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? "..." : "Continue"}
          </Button>
        </form>
      </div>
    </div>
  );
}
